import Graphics from 'core/display/Graphics'
import makeContainer from 'core/display/simple/Container'
import makeGraphics from 'core/display/simple/Graphics'
import TextCreate from 'core/display/simple/Text'
import { enableDrag } from 'core/handlers/DragHandler'
import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'
import { create } from 'utils/Object'

export default class AutoCarousel extends PIXI.Container{
  constructor(data) {
    super()
    this.data = data
    this.numbers = new makeContainer
    this.mask = new makeGraphics({
      width: data.width * 3,
      height: data.height,
    })
    this.mask.x = -data.width
    this.prev = Number.NaN
    this.click = false
    this.texts = game.models.AutoCountModel.getList().map(this.makeData.bind(this)).map(this.createText.bind(this))
    this.texts.forEach(this.applyPosition.bind(this))

    this.numbers.addChild(...this.texts)
    this.numbers.addChild(new makeGraphics(create(data, { alpha: 0 })))
    this.addChild(this.numbers, this.mask)

    signal.on('MODEL:AUTO', () => {
      if (isNaN(this.prev)) {
        gsap.killTweensOf(this.numbers)
        gsap.to(this.numbers, 0.3, { x: -game.models.AutoCountModel.getID() * this.data.width })
      }
    })

    enableDrag (this.numbers, { start: this.start, move: this.move, stop: this.stop })

  }

  makeData(text) {
    return create(this.data, { text })
  }

  applyPosition(text, idx) {
    const rectangle = new Graphics({
      alpha: 0,
      width: text.width * 2,
      height: text.height * 2,
    })

    rectangle.x = (text.width - rectangle.width / 2)
    rectangle.y = (text.height - rectangle.height / 2)

    text.addChild(rectangle)

    text.x = idx * this.data.width
    text.y = 0
  }

  createText(data){
    return new TextCreate(data)
  }

  start({ x }) {
    this.click = true
    this.prev = x
  }

  move({ x }) {
    this.click = this.click && Math.round(x) === Math.round(this.prev)
    this.numbers.x += x - this.prev
    this.numbers.x = this.numbers.x > 0 ? 0 : this.numbers.x < -game.models.AutoCountModel.getMaxID() * this.data.width ? -game.models.AutoCountModel.getMaxID() * this.data.width : this.numbers.x
    this.prev = x
    game.models.AutoCountModel.setID(Math.round(-this.numbers.x / this.data.width))
  }

  stop(point) {
    this.prev = Number.NaN
    if (this.click) {
      point = this.toLocal(point)
      game.models.AutoCountModel.setID(game.models.AutoCountModel.getID() + (point.x < 0 ? -1 : point.x > this.data.width ? 1 : 0))
    }
    else {
      game.models.AutoCountModel.setID(Math.round(-this.numbers.x / this.data.width))
    }
    signal.dispatch('SOUND:carousel')
  }
}
